import { useEffect } from "react";
import { fetchData } from "../service/ganttChartFetchService";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import useDataSelector from "./useDataSelector";
import { useQueryParams } from "./useQueryParams";
import { useSolutionPlanView } from "./useSolutionPlanView";

// /**
//  * Custom hook to call backend when either the three query params
//  * changes: filterId, date or selectedTab.
//  */
export const useFetchOnQueryChange = () => {
  const planViewState = useSolutionPlanView();
  const queryObject = useQueryParams();
  const dispatch = useAppDispatch();
  const { activeSession } = useAppSelector((state) => state.dragAndDropSlice);
  const { selectedGanttChartTab } = useAppSelector(
    (state) => state.ganttChartSlice,
  );
  const dataToUse = useDataSelector();

  useEffect(() => {
    if (
      (planViewState.status === "ready" && !dataToUse) ||
      selectedGanttChartTab === "Custom"
    ) {
      fetchData(dispatch, planViewState, queryObject, activeSession, dataToUse); //Fetches either GanttChartData or sends drag and drop handshake.
    }
  }, [planViewState, queryObject, selectedGanttChartTab]);
};
